<template>
  <span class="breadcrumbs-generator" data-test="breadcrumb-links">
    <slot />
    <template
      v-for="(breadcrumb, index) of breadcrumbs"
      :key="`divider-${index}`"
    >
      <span v-if="index > 0" class="crumb">&rsaquo;</span
      ><pu-link
        v-bind="breadcrumb.to"
        :exclude-type="
          isCityLevel(breadcrumb.hierarchyPath)
            ? 'breadcrumbCity'
            : 'breadcrumb'
        "
        :disabled="!breadcrumb.linkable"
        :non-seo="breadcrumb.nonSeo"
        :emit-events="true"
        :debug-breadcrumbs="false"
        :data-hierarchy-count="breadcrumb.debugData?.hierarchyCount?.toString()"
        :data-linkable="breadcrumb.debugData?.linkable?.toString()"
        :data-non-seo="breadcrumb.debugData?.nonSeo?.toString()"
        :data-hierarchy-path="breadcrumb.debugData?.hierarchyPath"
        :data-breadcrumb-level="breadcrumb.debugData?.level?.toString()"
        @url-generated="
          (url) =>
            updateRenderedUrl(
              breadcrumb.hierarchyPath || breadcrumb.label,
              breadcrumb.label,
              url,
            )
        "
        @click="logGtmEvent(breadcrumb.debugData?.level)"
        >{{ breadcrumb.label }}</pu-link
      ><span
        v-if="withCounts && !!breadcrumb.count"
        :key="`${index}${breadcrumb.label}count`"
        class="count"
        >({{ breadcrumb.count }})</span
      >
    </template>
    <slot name="flag" />
  </span>
</template>

<script setup lang="ts">
import type { SimpleBreadcrumbWithCount } from '~/components/search/types'

const { $gtm } = useNuxtApp()

defineProps<{
  breadcrumbs: SimpleBreadcrumbWithCount[]
  withCounts?: boolean
}>()

const emit = defineEmits<{
  'update-rendered-url': [{ key: string; label: string; url: string }]
}>()

const updateRenderedUrl = (key: string, label: string, url: string) => {
  emit('update-rendered-url', { key, label, url })
}

const isCityLevel = (hierarchyPath?: string): boolean => {
  if (!hierarchyPath) {
    return false
  }
  const level = hierarchyPath.split('/').filter((part) => part !== '').length
  return level === 4
}

function logGtmEvent(level) {
  $gtm.push({
    event: 'breadcrumb_click',
    level: `${level}`,
  })
}
</script>

<style>
@import url('~/assets/css/breadcrumbs.css');
</style>
